import { render, staticRenderFns } from "./OfficerOpenRecruitmentManagerEdit.vue?vue&type=template&id=b86cd19c&"
import script from "./OfficerOpenRecruitmentManagerEdit.vue?vue&type=script&lang=js&"
export * from "./OfficerOpenRecruitmentManagerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports